var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRafCompanyCustomerHint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 260,
    viewBox: "0 0 360 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 260,
    fill: "#DEDEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9668,
    height: 3650,
    transform: "translate(-2106 -2827)",
    fill: "#E6E6E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-540 -411)",
    fill: "#141A1F",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_11_1512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-120 -130C-120 -134.418 -116.418 -138 -112 -138H472C476.418 -138 480 -134.418 480 -130V332C480 336.418 476.418 340 472 340H-112C-116.418 340 -120 336.418 -120 332V-130Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.5 -130C-119.5 -134.142 -116.142 -137.5 -112 -137.5H472C476.142 -137.5 479.5 -134.142 479.5 -130V332C479.5 336.142 476.142 339.5 472 339.5H-112C-116.142 339.5 -119.5 336.142 -119.5 332V-130Z",
    stroke: "#E8ECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M326.886 158.384C326.886 158.384 383.885 13.3653 233.843 11.3329C83.7999 9.30044 15.1949 31.5631 14.517 105.317C13.8391 179.072 67.8817 247.998 162.07 248.762C256.259 249.525 307.193 221.776 326.886 158.384Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M56.6997 237.144V177.851H301.545V199.196L279.101 205.752L256.657 213.914L211.768 230.237L137.861 205.752L56.6997 237.144Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4116 34.4456C60.5574 34.4456 56.6223 38.3806 56.6223 43.2348V226.676L137.835 195.284L211.789 219.769L279.164 195.284L301.622 188.727L301.622 43.2348C301.622 38.3806 297.687 34.4456 292.833 34.4456H65.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.164 195.284L301.622 188.727L301.622 43.2348C301.622 38.3806 297.687 34.4456 292.833 34.4456H65.4116C60.5574 34.4456 56.6223 38.3806 56.6223 43.2348V226.676L137.835 195.284L211.789 219.769L279.164 195.284ZM211.739 216.28L278.138 192.15L298.326 186.256L298.326 43.2348C298.326 40.2009 295.867 37.7415 292.833 37.7415H65.4116C62.3777 37.7415 59.9183 40.2009 59.9183 43.2348V221.868L137.749 191.784L211.739 216.28Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3867 69.6016H114.8V73.2289H78.3867V69.6016Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3867 77.6237H114.8V81.251H78.3867V77.6237Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3869 95.7601H221.527V99.3874H78.3869V95.7601Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3869 103.782H221.527V107.41H78.3869V103.782Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3869 111.804H221.527V115.432H78.3869V111.804Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3869 119.826H221.527V123.454H78.3869V119.826Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3869 127.848H221.527V131.476H78.3869V127.848Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3869 135.871H221.527V139.498H78.3869V135.871Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3869 143.892H174.442V147.519H78.3869V143.892Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5 69.6016H279.913V73.2289H243.5V69.6016Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5 77.6237H273.635V81.251H243.5V77.6237Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5 85.6458H279.913V89.2731H243.5V85.6458Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5 93.6679H273.635V97.2952H243.5V93.6679Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5 101.69H273.635V105.317H243.5V101.69Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5 109.711H273.635V113.338H243.5V109.711Z",
    fill: "#8599AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.419 108.965L287.344 119.531L318.106 143.045L326.181 132.478L295.419 108.965Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M295.419 108.965L287.344 119.531L318.106 143.045L326.181 132.478L295.419 108.965Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.912 122.98L307.504 139.217L347.002 169.408L359.41 153.171L319.912 122.98Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.009 66.067C220.774 72.9213 217.691 81.1745 217.147 89.783C216.603 98.3915 218.625 106.969 222.955 114.43C227.286 121.891 233.731 127.902 241.476 131.701C249.221 135.501 257.918 136.919 266.467 135.777C275.017 134.634 283.035 130.982 289.507 125.282C295.98 119.582 300.616 112.091 302.83 103.755C305.044 95.4189 304.737 86.6126 301.947 78.4497C299.156 70.2868 294.009 63.1338 287.154 57.895C282.602 54.4157 277.409 51.8671 271.872 50.3948C266.335 48.9224 260.563 48.5552 254.885 49.314C249.206 50.0729 243.734 51.943 238.779 54.8175C233.825 57.692 229.485 61.5146 226.009 66.067ZM285.149 111.242C281.454 116.092 276.403 119.737 270.635 121.715C264.867 123.693 258.641 123.914 252.746 122.352C246.851 120.79 241.551 117.515 237.517 112.94C233.483 108.365 230.897 102.696 230.085 96.652C229.274 90.6076 230.274 84.4589 232.959 78.9843C235.643 73.5096 239.892 68.955 245.167 65.8969C250.443 62.8388 256.507 61.4148 262.593 61.8051C268.679 62.1953 274.513 64.3822 279.356 68.0891C285.817 73.0392 290.062 80.3408 291.166 88.4039C292.27 96.467 290.144 104.639 285.251 111.14L285.149 111.242Z",
    fill: "#EE8B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_11_1512",
    x: -152,
    y: -168,
    width: 664,
    height: 542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_1512"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_11_1512",
    result: "effect2_dropShadow_11_1512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_11_1512",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRafCompanyCustomerHint);
export default __webpack_public_path__ + "static/media/raf_company_customer_hint.6429bc4d05b7b3b09d263ef39892dbc7.svg";
export { ForwardRef as ReactComponent };